import { useState } from "react";
import PasswordModal from "./PasswordModal";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState(false);

  const handlePasswordSubmit = (password) => {
    const correctPassword = process.env.REACT_APP_PASSWORD;

    if (password === correctPassword) {
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (!isAuthenticated) {
    return (
      <PasswordModal onPasswordSubmit={handlePasswordSubmit} error={error} />
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh", margin: 0, padding: 0 }}>
      <iframe
        src="https://www.figma.com/embed?embed_host=share&url=https://www.figma.com/proto/FKDL8CRWUe6RCbNUQhKPUh/NEX3-Prototype?node-id=43140-14536&scaling=scale-down&page-id=13549%3A7382"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Figma Prototype"
        allowFullScreen
      />
    </div>
  );
}

export default App;
